module.exports = __webpack_public_path__ + "static/media/textchat.b67631dd.ico";